import { ReactElement } from 'react';

import { SidePanelContentSlot } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../translations';

import { PatientConsentsAndAuthorizationsSidePanelLink } from './PatientConsentsAndAuthorizationsSidePanelLink';
import { PatientConsentsAndAuthorizationsSidePanelList } from './PatientConsentsAndAuthorizationsSidePanelList';
import { PatientConsentsAndAuthorizationsSidePanelListLoader } from './PatientConsentsAndAuthorizationsSidePanelList.loader';

type PatientConsentsAndAuthorizationsSidePanelContentSlotProps = {
   readonly patientId: number;
};

export const PatientConsentsAndAuthorizationsSidePanelContentSlot = (
   props: PatientConsentsAndAuthorizationsSidePanelContentSlotProps
): ReactElement => {
   return (
      <SidePanelContentSlot headerText={patientConsentsAndAuthorizationsTranslationKeys.header}>
         <PatientConsentsAndAuthorizationsSidePanelLink patientId={props.patientId} />

         <PatientConsentsAndAuthorizationsSidePanelListLoader patientId={props.patientId}>
            {({ patientConsents, patientAuthorizations }) => (
               <PatientConsentsAndAuthorizationsSidePanelList
                  patientConsents={patientConsents}
                  patientAuthorizations={patientAuthorizations}
               />
            )}
         </PatientConsentsAndAuthorizationsSidePanelListLoader>
      </SidePanelContentSlot>
   );
};
